import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const FileLock1 = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 24 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M9.6 21.6H7.2C5.2116 21.6 3.6 19.9884 3.6 18V6C3.6 4.0119 5.2116 2.4 7.2 2.4H15.6C17.5881 2.4 19.2 4.0119 19.2 6V9M15 15V13.8C15 12.806 15.806 12 16.8 12C17.794 12 18.6 12.806 18.6 13.8V15.6M14.4 21.6H19.2C19.8626 21.6 20.4 21.0629 20.4 20.4V16.8C20.4 16.1374 19.8626 15.6 19.2 15.6H14.4C13.7371 15.6 13.2 16.1374 13.2 16.8V20.4C13.2 21.0629 13.7371 21.6 14.4 21.6Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
})

export default FileLock1
